import { Component } from '@angular/core';
import { NavigService } from 'src/app/services/navig.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {
  constructor(
    public nav : NavigService
  ){}
  ongletsVis = false;
  ongletsVisDevis = false;
  menuOpen = false;

  ///---------------------------------
  goFb(){
    window.open("https://www.facebook.com/profile.php?id=100091342660069", "_blank");
  }
  goLn(){
    window.open("https://www.linkedin.com/company/mace-assurance/", "_blank");
  }
  goInsta(){
    window.open("https://www.instagram.com/mace.assurance/", "_blank");
  }
//--------------------------------------

}
